/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    PositionUpdateFields,
} from './';

/**
 * @export
 * @interface PositionForBind
 */
export interface PositionForBind {
    /**
     * `Position Primary Key`
     * @type {number}
     * @memberof PositionForBind
     */
    position_id?: number;
    /**
     * @type {PositionUpdateFields}
     * @memberof PositionForBind
     */
    position_data?: PositionUpdateFields;
}
